import { TrapSongGenerator } from './trap/TrapSongGenerator'

export enum GeneratorMode {
  TRAP
  // Add more :)
}

export const getGenerator = (mode: GeneratorMode = GeneratorMode.TRAP) => {
  switch (mode) {
    case GeneratorMode.TRAP:
      return new TrapSongGenerator()
  }
}
